import "core-js/modules/es.array.includes.js";
import styled, { css } from 'styled-components';
var regularShadowTop = css(["box-shadow:rgb(34 34 90 / 0.1) 0 0 35px,rgb(0 0 0 / 0.07) 0 0 15px,rgb(34 34 90 / 0.07) 0 -1px 3px 1px,rgb(34 34 90 / 0.05) 0 1px 0 0;"]);
var regularShadowBottom = css(["box-shadow:rgb(34 34 90 / 0.1) 0 0 35px,rgb(0 0 0 / 0.07) 0 0 15px,rgb(34 34 90 / 0.07) 0 1px 3px 1px,rgb(34 34 90 / 0.05) 0 -1px 0 0;"]);
var topStyles = css(["", ";margin-bottom:8px;&:before{bottom:-8px;border-width:8px 8px 0;border-color:", " transparent transparent;}&:after{bottom:-7px;border-width:7px 7px 0;border-color:", " transparent transparent;}"], regularShadowTop, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
}, function (_ref2) {
  var theme = _ref2.theme,
    type = _ref2.type;
  return type === 'entity' ? theme.colors.uiLL : '#fff';
});
var bottomStyles = css(["", ";margin-top:8px;&:before{top:-8px;border-width:0 8px 8px;border-color:transparent transparent ", ";}&:after{top:-7px;border-width:0 7px 7px;border-color:transparent transparent #fff;}"], regularShadowBottom, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.ui;
});
var xRightStyles = css(["", ";margin-top:14px;&:before{top:14px;left:-12px;border-width:0 8px 8px;border-color:transparent transparent ", ";transform:rotate(-90deg);}&:after{top:14px;left:-10px;border-width:0 7px 7px;border-color:transparent transparent #fff;transform:rotate(-90deg);}"], regularShadowBottom, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.ui;
});
var X_STYLES = {
  top: topStyles,
  bottom: bottomStyles,
  right: xRightStyles
};
var leftStyles = css(["&:before{left:", "px;}&:after{left:", "px;}"], function (_ref5) {
  var arrowPos = _ref5.arrowPos;
  return arrowPos ? arrowPos : 15;
}, function (_ref6) {
  var arrowPos = _ref6.arrowPos;
  return arrowPos ? arrowPos + 1 : 16;
});
var rightStyles = css(["&:before{right:", "px;}&:after{right:", "px;}"], function (_ref7) {
  var arrowPos = _ref7.arrowPos;
  return arrowPos ? arrowPos : 15;
}, function (_ref8) {
  var arrowPos = _ref8.arrowPos;
  return arrowPos ? arrowPos + 1 : 16;
});
var centerStyles = css(["&:before{left:50%;margin-left:-10px;}&:after{left:50%;margin-left:-9px;}"]);
export var CardInner = styled.div.withConfig({
  displayName: "CardInner",
  componentId: "sc-e842jw-0"
})(["position:relative;border-radius:", ";background-color:#fff;", " ", ";&:before,&:after{position:absolute;z-index:2;width:0;height:0;border-style:solid;content:'';}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.borderRadius;
}, function (_ref10) {
  var posX = _ref10.posX;
  return posX ? X_STYLES[posX] : '';
}, function (_ref11) {
  var posY = _ref11.posY,
    posX = _ref11.posX;
  return ['bottom', 'top'].includes(posX) ? posY === 'right' ? rightStyles : posY === 'center' ? centerStyles : leftStyles : '';
});